import { Separator } from 'office-ui-fabric-react/lib/Separator';
import { useEffect, useState } from 'react';
import DocumentTitle from 'react-document-title';
import { useLocation, useHistory } from 'react-router';
import Auth from "../../Auth/Auth";
import { Link } from 'react-router-dom';
import ProccesingModalComponent from "./ProccesingModalComponent";
import { useBoolean } from '@fluentui/react-hooks';
import './Payments.sass';
import React from 'react';
import PaymentService, { PaymentStatuses, PaymentType } from '../../services/PaymentService';

const PaymentOk = () =>
{
    var activePlan = Auth.getActivePlan();
    const history = useHistory();
    const [payment, setPayment] = useState<PaymentType>();
    const [showBadHoldersError, setShowBadHoldersError] = useState(false);
    const [tryings, setTryings] = useState(0);
    const maxTryings = 12;
    const [isModalOpen, { setFalse: hideModal }] = useBoolean(true);
    const search = useLocation().search;
    const paymentId = new URLSearchParams(search).get('paymentId');

    useEffect(() =>
    {
        if (paymentId !== null)
        {
            console.log(`tryings: ${tryings} de ${maxTryings}`);
            if (tryings !== undefined && tryings < maxTryings)
            {
                PaymentService.getPayment(Number(paymentId)).then((payment: PaymentType) =>
                {
                    console.log('payment.status', payment.status);
                    setPayment(payment);
                },
                () => {
                    hideModal();
                });
            }
            else
            {
                hideModal();
            }
        }
        else {
            hideModal();
        }
    }, [paymentId, tryings]);

    useEffect(() =>
    {
        if (payment !== undefined)
        {
            console.log('payment.status', payment.status);
            switch (payment.status) {
                case PaymentStatuses.PENDING:
                    {
                        const timeoutId = setTimeout(() =>
                        {
                            setTryings((prevState: number) => prevState + 1);
                        }, 5000);

                        return () => clearTimeout(timeoutId);
                    }

                case PaymentStatuses.VALIDATED:
                    {
                        if (payment.usersSubscriptionId) {
                            if (payment.usersSubscriptionId === activePlan.userSubscriptionId) {
                                activePlan.statusName = 4;
                                activePlan.outdated = false;
                                activePlan.cancelled = false;
                                Auth.setActivePlan(activePlan);
                            }
                            hideModal();
                            break;
                        }

                        if (payment.orders && payment.orders.length > 0 && payment.orders.every(o => o.status === 3)) {
                            history.push('/portfolio/orders');
                            break;
                        }

                        const timeoutId = setTimeout(() =>
                        {
                            setTryings((prevState: number) => prevState + 1);
                        }, 5000);

                        return () => clearTimeout(timeoutId);
                    }

                case PaymentStatuses.BAD_HOLDERS:
                    setShowBadHoldersError(true);
                    hideModal();
                    break;

                default:
                    hideModal();
            }
        }
    }, [payment]);

    return (
        <DocumentTitle title='IronIA - Pago correcto'>
            <React.Fragment>
                {!showBadHoldersError && (
                    <>
                        <h3>Pago realizado</h3>
                        <p className="description">El pago se ha realizado correctamente</p>
                        <Separator className="separator" />
                        {payment?.usersSubscriptionId !== undefined && payment?.usersSubscriptionId !== null && (
                            <React.Fragment>
                                {payment.usersSubscriptionId !== activePlan.userSubscriptionId &&
                                (
                                    <p className="text-right">
                                        <Link className="button primary-button" to={'/savingsPlans'}>
                                            Planes de Cartera en configuración
                                        </Link>
                                    </p>
                                )}
                                {payment.usersSubscriptionId === activePlan.userSubscriptionId &&
                                (
                                    <p className="text-right">
                                        <Link className="button primary-button" to={
                                        {
                                            pathname: '/configurationMap', state:
                                            {
                                                savingPlanId: activePlan.id,
                                                savingPlanName: activePlan.name
                                            }
                                        }}>
                                            Continuar configurando el plan de cartera
                                        </Link>
                                    </p >
                                )}
                            </React.Fragment>
                        )}
                    </>
                )}
                {showBadHoldersError && (
                    <div className="ms-Grid-row p10">
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12">
                            <div className="section-row">
                                <div className="warning-container">
                                    <div>
                                        <img
                                            src="/icons/information.svg"
                                            alt="Información"
                                        />
                                    </div>
                                    <p><i> Atención.</i></p>
                                    <p>
                                        <i>
                                            El titular de la cuenta desde la que se ha realizado el pago no corresponde con ningún titular del contrato. Se ha procedido a la cancelación del pago.
                                        </i>
                                    </p>
                                    <p>
                                        <i>Por favor, pongase en contacto con <a href="mailto:info@ironia.tech">info@ironia.tech</a></i>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <ProccesingModalComponent isModalOpen={isModalOpen} hideModal={hideModal} />
            </React.Fragment>
        </DocumentTitle>
    );
};

export default PaymentOk;